import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../state/actions/actionsWrapper";
import { RootState } from "../state/reducers";

export const useTrangThaiDiemDanh = () => {
    const { nt_diem_danh_trang_thais } = useSelector((state: RootState) => state.danhMucWrapper.trangThai);

    const dispatch = useDispatch();

    const handleRefresh = useCallback(() => {
        dispatch(actions.danhMucWrapper.trangThai.loadStart())
    }, [dispatch]);
    useEffect(() => {
        handleRefresh();
    }, [handleRefresh])
    return {
        nt_diem_danh_trang_thais: nt_diem_danh_trang_thais
    };
}
